import { render } from "./DashboardRTL.vue?vue&type=template&id=33f55a7c&scoped=true"
import script from "./DashboardRTL.vue?vue&type=script&lang=js"
export * from "./DashboardRTL.vue?vue&type=script&lang=js"

import "./DashboardRTL.vue?vue&type=style&index=0&id=33f55a7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f55a7c"]])

export default __exports__